import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import FormField from "../FormField";
import Modal from "../Modal";
import { setLoader } from "../../features/LoaderSlice";
import { useIntl } from "react-intl";
import useTracker from "../../hooks/useTracker";
import useCollect from "../../hooks/useCollect";
import UnsavedModal from "../UnsavedModal";
import { isFieldRestricted } from "../../features/configSlice";
import {
  FieldContactEmail,
  FieldFirstName,
  FieldLastName,
  FieldSalutation,
  FieldTitle,
} from "../../utils/controls";
const UpdateIdentity = ({
  isUpdateOpen,
  setIsUpateOpen,
  user,
  getUserDetails,
  isUnsavedUpdateOpen,
  setIsUnsavedUpdateOpen,
  refresh,
}) => {
  const intl = useIntl();
  const {
    salutation,
    title,
    first_name,
    last_name,
    controllerCode,
    customerScope,
    type,
    value,
    language,
    contactEmail,
  } = user;
  const dispatch = useDispatch();
  const state = useSelector((state) => state.config);
  const { countryLanguages } = useSelector((state) => state.controller);
  const {
    identityCollect,
    handleCollectSuccessMessage,
    handleCollectErrorMessage,
  } = useCollect();
  const [formData, setFormData] = useState({
    salutation: salutation,
    title: title,
    first_name: first_name,
    last_name: last_name,
    type: type,
    value: value,
    language: language,
    contact_email: contactEmail,
    customer_scope: customerScope,
    controller_code: controllerCode,
    collection_channel: "Truman UI",
    last_update_channel: "Truman UI",
  });
  const { updateIdentityTracker, removeCreateIdentityTracker } = useTracker();
  const trackerDeatils = useSelector((state) => state?.TrackerReducer);
  const [customSelectLanguageActive, setCustomSelectLanguageActive] =
    useState(false);

  useEffect(() => {
    if (
      trackerDeatils &&
      trackerDeatils?.form_type == "update" &&
      trackerDeatils?.modal_type == "update"
    ) {
      setFormData({ ...trackerDeatils?.form });
      setIsUpateOpen(true);
      setIsUnsavedUpdateOpen(true);
    }
  }, []);
  const handleChange = async (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    updateIdentityTracker({ ...formData, [e.target.name]: e.target.value });
  };

  const haveRequiredValues = useMemo(() => {
    if (
      formData?.first_name &&
      formData?.last_name &&
      formData?.type &&
      formData?.value &&
      formData?.language
    )
      return true;
    else return false;
  }, [formData]);
  const submitUpdate = () => {
    setFormData({
      ...formData,
      hasSubmited: true,
    });
    if (!haveRequiredValues) return;
    dispatch(setLoader({ loading: true, label: "" }));
    setTimeout(refresh, "5000");
    identityCollect(formData, false, false, {}, false)
      .then((res) => {
        getUserDetails();
        handleCollectSuccessMessage(res);
        setIsUpateOpen(false);
        removeCreateIdentityTracker();
      })
      .catch((error) => {
        handleCollectErrorMessage(error);
        dispatch(setLoader({ loading: false, label: "" }));
        setTimeout(refresh, "5000");
        setIsUpateOpen(false);
      });
  };
  const handleCloseAndCancel = async () => {
    if (trackerDeatils?.form_type !== "update") {
      setIsUnsavedUpdateOpen(false);
      setIsUpateOpen(false);
    } else setIsUnsavedUpdateOpen(true);
  };
  const handleCloseAndCancelUnsaved = async () => {
    setIsUnsavedUpdateOpen(false);
  };
  const handleClickOutside = async () => {
    if (trackerDeatils?.form_type !== "update") {
      setIsUnsavedUpdateOpen(false);
    } else setIsUnsavedUpdateOpen(true);
  };
  const handleDiscardUnsaved = async () => {
    setIsUnsavedUpdateOpen(false);
    setFormData({
      salutation: salutation,
      title: title,
      first_name: first_name,
      last_name: last_name,
      type: type,
      value: value,
      language: language,
      contact_email: contactEmail,
      customer_scope: customerScope,
      controller_code: controllerCode,
      collection_channel: "Truman UI",
      last_update_channel: "Truman UI",
    });
    setTimeout(() => {
      setIsUpateOpen(false);
    }, 300);
    removeCreateIdentityTracker();
  };
  useEffect(() => {
    const trakerForm = trackerDeatils?.form;
    setFormData({
      salutation: trakerForm?.salutation || salutation,
      title: trakerForm?.title || title,
      first_name: trakerForm?.first_name || first_name,
      last_name: trakerForm?.last_name || last_name,
      type: trakerForm?.type || type,
      value: trakerForm?.value || value,
      language: trakerForm?.language || language,
      contact_email: trakerForm?.contact_email || contactEmail,
      customer_scope: trakerForm?.customer_scope || customerScope,
      controller_code: trakerForm?.controller_code || controllerCode,
      collection_channel: trakerForm?.collection_channel || "Truman UI",
      last_update_channel: trakerForm?.last_update_channel || "Truman UI",
    });
  }, [
    salutation,
    title,
    first_name,
    last_name,
    controllerCode,
    customerScope,
    type,
    value,
    language,
    contactEmail,
  ]);
  const handleCustomClick = (fieldName) => {
    if (fieldName === "language")
      setCustomSelectLanguageActive(!customSelectLanguageActive);
  };

  return (
    <>
      <Modal
        title={intl.formatMessage({
          id: "id.edit.title",
          defaultMessage: "Edit Profile details",
        })}
        description={intl.formatMessage({
          id: "id.edit.description",
          defaultMessage:
            " Please note changes made to these details within Truman UI will not be reflected in Veeva",
        })}
        open={isUpdateOpen}
        setOpen={setIsUpateOpen}
        okText={intl.formatMessage({
          id: "label.update-profile",
          defaultMessage: "UPDATE PROFILE",
        })}
        canelText={intl.formatMessage({
          id: "label.cancel",
          defaultMessage: "Cancel",
        })}
        type="form"
        onSubmit={submitUpdate}
        onCancel={handleCloseAndCancel}
        handleClose={handleCloseAndCancel}
        handleClickOutside={handleClickOutside}
      >
        <div className="row" style={{ marginBottom: 10 }}>
          {!isFieldRestricted(state, FieldSalutation) && (
            <div className="col-md-2">
              <div className="form-group">
                <FormField
                  formType="create"
                  value={formData?.salutation}
                  name="salutation"
                  type="text"
                  id="salutation"
                  label={intl.formatMessage({
                    id: "label.salutation",
                    defaultMessage: "Salutation",
                  })}
                  placeHolder={intl.formatMessage({
                    id: "id.new-placeholder.salutation",
                    defaultMessage: "Salutation",
                  })}
                  handleChange={handleChange}
                />
              </div>
            </div>
          )}
          {!isFieldRestricted(state, FieldTitle) && (
            <div className="col-md-2">
              <div className="form-group">
                <FormField
                  formType="create"
                  value={formData?.title}
                  name="title"
                  type="text"
                  id="title"
                  label={intl.formatMessage({
                    id: "label.title",
                    defaultMessage: "Title",
                  })}
                  placeHolder={intl.formatMessage({
                    id: "id",
                    defaultMessage: "Title",
                  })}
                  handleChange={handleChange}
                />
              </div>
            </div>
          )}
          {!isFieldRestricted(state, FieldFirstName) && (
            <div className="col-md-4">
              <div className="form-group">
                <FormField
                  formType="create"
                  value={formData?.first_name}
                  name="first_name"
                  type="text"
                  id="first_name"
                  label={intl.formatMessage({
                    id: "label.first-name",
                    defaultMessage: "First Name",
                  })}
                  placeHolder={intl.formatMessage({
                    id: "id.new-placeholder.first-name",
                    defaultMessage: "Please Enter First Name",
                  })}
                  handleChange={handleChange}
                  rules={{
                    required: true,
                    hasSubmitted: formData?.hasSubmited,
                  }}
                />
              </div>
            </div>
          )}
          {!isFieldRestricted(state, FieldLastName) && (
            <div className="col-md-4">
              <div className="form-group">
                <FormField
                  formType="create"
                  value={formData?.last_name}
                  name="last_name"
                  type="text"
                  id="last_name"
                  label={intl.formatMessage({
                    id: "label.last-name",
                    defaultMessage: "Last Name",
                  })}
                  placeHolder={intl.formatMessage({
                    id: "id.new-placeholder.last-name",
                    defaultMessage: "Please Enter Last Name",
                  })}
                  handleChange={handleChange}
                  rules={{
                    required: true,
                    hasSubmitted: formData?.hasSubmited,
                  }}
                />
              </div>
            </div>
          )}
        </div>
        <div className="row" style={{ marginBottom: 10 }}>
          <div className="col-md-4">
            <div className="form-group">
              <FormField
                formType="create"
                value={formData?.type}
                name="type"
                type="input"
                id="type"
                label={intl.formatMessage({
                  id: "label.id-type",
                  defaultMessage: "ID Type",
                })}
                placeHolder={intl.formatMessage({
                  id: "id.new-placeholder.id-type",
                  defaultMessage: "Please Select ID Type",
                })}
                handleChange={handleChange}
                disabled
                rules={{
                  required: true,
                  hasSubmitted: formData?.hasSubmited,
                }}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <FormField
                formType="create"
                value={formData?.value}
                name="value"
                type="text"
                id="value"
                label={intl.formatMessage({
                  id: "label.id-value",
                  defaultMessage: "ID Value",
                })}
                placeHolder={intl.formatMessage({
                  id: "id.new-placeholder.id-value",
                  defaultMessage: "Please Enter ID Value",
                })}
                handleChange={handleChange}
                disabled
                rules={{
                  required: true,
                  hasSubmitted: formData?.hasSubmited,
                }}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <FormField
                formType="create"
                value={formData?.language}
                name="language"
                type="select"
                id="language"
                label={intl.formatMessage({
                  id: "label.language",
                  defaultMessage: "Language",
                })}
                placeHolder={intl.formatMessage({
                  id: "id.new-placeholder.language",
                  defaultMessage: "Please Select Language",
                })}
                handleChange={handleChange}
                options={countryLanguages}
                rules={{
                  required: true,
                  hasSubmitted: formData?.hasSubmited,
                }}
                handleCustomClick={(e) => handleCustomClick(e.target.name)}
                customSelectActive={customSelectLanguageActive}
              />
            </div>
          </div>
        </div>
        {!isFieldRestricted(state, FieldContactEmail) && (
          <div className="row" style={{ marginBottom: 10 }}>
            <div className="col-md-12">
              <div className="form-group">
                <FormField
                  formType="create"
                  value={formData?.contact_email}
                  name="contact_email"
                  type="email"
                  id="contact_email"
                  label={intl.formatMessage({
                    id: "label.contact-email",
                    defaultMessage: " Contact Email",
                  })}
                  placeHolder={intl.formatMessage({
                    id: "id.new-placeholder.contact-email",
                    defaultMessage: "Please Enter Contact Email",
                  })}
                  handleChange={handleChange}
                />
              </div>
            </div>
          </div>
        )}
      </Modal>
      <UnsavedModal
        title={intl.formatMessage({
          id: "unsaved.title",
          defaultMessage: "Unsaved changes",
        })}
        subTitle={intl.formatMessage({
          id: "unsaved.subtitle",
          defaultMessage: "Are you sure you want to leave?",
        })}
        description={intl.formatMessage({
          id: "unsaved.description",
          defaultMessage:
            "You have unsaved changes. You can leave and discard the changes or cancel to continue editing.",
        })}
        open={isUnsavedUpdateOpen}
        setOpen={setIsUnsavedUpdateOpen}
        okText={intl.formatMessage({
          id: "unsaved.discardchanges",
          defaultMessage: "Discard changes",
        })}
        canelText={intl.formatMessage({
          id: "label.cancel",
          defaultMessage: "Cancel",
        })}
        handleClose={handleCloseAndCancelUnsaved}
        handleDiscard={handleDiscardUnsaved}
      />
    </>
  );
};

export default UpdateIdentity;
